function isOverlappingAbsence(newAbs, absences, editingId = null, userId = null) {
  if (!absences || absences.length === 0 || !userId) return false;

  //only check overlaps with the current user's absences
  const userAbsences = absences.filter(a => a.user_id === userId);

  const filteredAbsences = editingId
    ? userAbsences.filter(a => a.id !== editingId)
    : userAbsences;

  if (newAbs.is_half_day) {
    //only check for half-day absences on the same day and overlapping time
    const newDate = newAbs.start_date;
    const [newStartHour, newStartMin] = newAbs.start_time.split(":").map(Number);
    const [newEndHour, newEndMin] = newAbs.end_time.split(":").map(Number);
    const newStart = newStartHour * 60 + newStartMin;
    const newEnd = newEndHour * 60 + newEndMin;

    return filteredAbsences.some(abs => {
      if (!abs.is_half_day) return false;
      if (abs.start_date !== newDate) return false;
      const [existStartHour, existStartMin] = abs.start_time.split(":").map(Number);
      const [existEndHour, existEndMin] = abs.end_time.split(":").map(Number);
      const existStart = existStartHour * 60 + existStartMin;
      const existEnd = existEndHour * 60 + existEndMin;
      // check if intervals overlap
      return newStart < existEnd && newEnd > existStart;
    });
  } else {
    //for full/multiple days, check date overlap as before
    const newStart = new Date(newAbs.start_date);
    const newEnd = new Date(newAbs.end_date || newAbs.start_date);

    for (const absence of filteredAbsences) {
      const existingStart = new Date(absence.start_date);
      const existingEnd = new Date(absence.end_date || absence.start_date);

      //check if ranges overlap
      if (newStart <= existingEnd && newEnd >= existingStart) {
        return true;
      }
    }
    return false;
  }
}

export default isOverlappingAbsence;